<style>

    img{
        width: 50%;
    }

</style>
<template>
    <table-template ref="member-table-template" actionUrl="/dbtCard/findMembers.action" :queryParams="queryParams">
        <template slot="search">

            <el-select v-model="queryParams.isCar" @change="$refs['member-table-template'].search()" clearable  placeholder="是否绑定车辆">
                <el-option label="已绑定车辆" :value="1"></el-option>
                <el-option label="未绑定车辆" :value="2"></el-option>
            </el-select>

            <el-select v-model="queryParams.timeType" @change="$refs['member-table-template'].search()"    placeholder="时间类型">
                <el-option label="注册时间" :value="1"></el-option>
                <el-option label="最近活跃" :value="2"></el-option>
                <el-option label="开通会员时间" :value="3"></el-option>
                <el-option label=" 会员到期时间" :value="4"></el-option>
            </el-select>

            <el-date-picker
                    clearable
                    style="margin-left: 10px;"
                    v-model="createTimeSearch"
                    @change="onCreateTimeChanged"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="开始时间"
                    end-placeholder="结束时间">
            </el-date-picker>

            <el-input style="margin-left: 10px;width: 200px;" v-model="queryParams.keyword" placeholder="昵称/手机号/邀请人昵称"></el-input>
            <el-button style="margin-left: 10px;" type="primary" @click="$refs['member-table-template'].search()">搜索</el-button>
            <el-button type="warning" @click="exportExcel()">导出</el-button>
        </template>
        <template slot="item">
            <el-table-column
                    label="用户信息" width="200px">
                <template scope="scope">
                    {{scope.row.nickname }}
                    <br>
                    {{scope.row.phone }}
                </template>
            </el-table-column>
            <el-table-column
                    label="个人实名认证" width="110px">
                <template scope="scope">
                   <span v-bind:style="{color:getRealNameAuthColor(scope.row.realNameAuth)}">{{scope.row.realNameAuth | realNameAuthStatusFilter}}</span>
                    <div>{{scope.row.realName}}</div>
                </template>
            </el-table-column>
            <el-table-column
                    label="注册活跃">
                <template scope="scope">
                    注册时间：{{scope.row.openTime | dateTimeFormat}}
                    <br>
                    最近活跃：{{scope.row.loginTime | dateTimeFormat}}
                </template>
            </el-table-column>

            <el-table-column
                    prop="cardCount"
                    label="会员时间">
                <template scope="scope">
                    开通会员：{{scope.row.createTime | dateTimeFormat}}
                    <br>
                    会员到期：{{scope.row.endTime | dateTimeFormat}}

                </template>
            </el-table-column>
            <el-table-column
                    label="关系">
                <template scope="scope">
                    <span v-if="scope.row.inviterId">邀请人：{{scope.row.inviterName}} - {{scope.row.inviterPhone}}</span>
                    <span v-else>邀请人：区域服务商</span>
                    <br>
                    <span v-if="scope.row.dealerName">合伙人：{{scope.row.dealerName}} - {{scope.row.dealerPhone}} </span>
                    <span v-else>合伙人：暂无</span>
                </template>
            </el-table-column>

            <el-table-column label="操作" width="120px">
                <template scope="scope">

                    <el-dropdown trigger="click">
                        <el-button class="el-dropdown-link" size="mini" type="primary">
                            更多操作<i class="el-icon-caret-bottom el-icon--right" style="color:#FFF"></i>
                        </el-button>
                        <el-dropdown-menu slot="dropdown">

                            <el-dropdown-item @click.native.prevent="$refs['realNameAuthDialog'].show(scope.row)" >实名认证</el-dropdown-item>
                            <el-dropdown-item type="text"  v-if="scope.row.role==1" v-confirm confirm-text="确认升级经纪人" requestUrl="distributor/upgradeFreeAgent.action" :confirm-data="{id:scope.row.id}"
                                              @onConfirm="$refs['member-table-template'].search()">升级经纪人</el-dropdown-item>

                            <el-dropdown-item type="text"  v-if="scope.row.role!=3" v-confirm confirm-text="确认升级合伙人" requestUrl="dbtCard/upgradeDealer.action" :confirm-data="{id:scope.row.id,cardCount:0}"
                                              @onConfirm="upgradeDealer()">升级为合伙人</el-dropdown-item>
                              <el-dropdown-item @click.native.prevent="showCarInfoData(scope.row.lcwpUserId)" >查看绑定车辆</el-dropdown-item>

                        </el-dropdown-menu>
                    </el-dropdown>

                    <clue-dialog ref="realNameAuthDialog"
                                 requestUrl= "dbtCard/changeRealNameAuthStatus.action"
                                 confirmText="审核通过"
                                 :confirmValue="{status:3}"
                                 title="个人认证审核"
                                 cancelText="审核不通过"
                                 :cancelValue="{status:1}"
                                 @confirm="onRealNameAuthConfirm">
                        <div slot="dialog-content" slot-scope="info">
                            <p>用户姓名：{{info.data.realName?info.data.realName:'暂无'}}</p>
                            <p>身份证号：{{info.data.idCardNo?info.data.idCardNo:'暂无'}}</p>
                            <p>申请时间：{{info.data.realNameAuthApplyTime | dateTimeFormat}}</p>
                            <el-image
                                    style="width: 200px; height: 200px"
                                    fit="cover"
                                    :src="imageBaseUrl+info.data.idCardPhotoFront"
                                    :preview-src-list="[imageBaseUrl+info.data.idCardPhotoFront,imageBaseUrl+info.data.idCardPhotoBack]">
                            </el-image>
                            <el-image
                                    style="width: 200px; height: 200px;margin-left:20px;"
                                    :src="imageBaseUrl+info.data.idCardPhotoBack"
                                    :preview-src-list="[imageBaseUrl+info.data.idCardPhotoFront,imageBaseUrl+info.data.idCardPhotoBack]">
                            </el-image>
                        </div>
                    </clue-dialog>

                    <clue-dialog ref="companyAuthDialog"
                                 requestUrl= "dbtCard/changeCompanyAuthStatus.action"
                                 confirmText="审核通过"
                                 :confirmValue="{status:3}"
                                 title="公司认证申请"
                                 cancelText="审核不通过"
                                 :cancelValue="{status:1}"
                                 @confirm="onRealNameAuthConfirm">
                        <div slot="dialog-content" slot-scope="info">
                            <p>公司名称：{{info.data.companyName?info.data.companyName:'暂无'}}</p>
                            <p>申请时间：{{info.data.companyApplyTime | dateTimeFormat}}</p>
                            <el-image
                                    style="width: 100px; height: 100px"
                                    fit="cover"
                                    :src="imageBaseUrl+info.data.companyLicensePhoto"
                                    :preview-src-list="[imageBaseUrl+info.data.companyLicensePhoto]">
                            </el-image>
                        </div>
                    </clue-dialog>

                    <el-dialog :visible.sync="dialogCarInfoFormVisible" label-width="80px" title="查看绑定车辆"
                               width="50%">

                        <el-table :data="carInfoDatas" class="basic-margin" style="width: 100%">
                            <el-table-column label="车牌号码" width="100px">
                                <template scope="scope">
                                    {{scope.row.carNumber}}
                                </template>
                            </el-table-column>

                            <el-table-column label="车架号/VIN" width="100px">
                                <template scope="scope">
                                    {{scope.row.carVehicleCode}}
                                </template>
                            </el-table-column>

                            <el-table-column label="发动机号" width="100px">
                                <template scope="scope">
                                    {{scope.row.carEngineNumber}}
                                </template>
                            </el-table-column>

                            <el-table-column label="使用性质" width="100px">
                                <template scope="scope">
                                    {{scope.row.useNature}}
                                </template>
                            </el-table-column>

                            <el-table-column label="注册日期" width="100px">
                                <template scope="scope">
                                    {{scope.row.carRegisterTime | dateFormat}}
                                </template>
                            </el-table-column>

                            <el-table-column label="品牌车型">
                                <template scope="scope">
                                    {{scope.row.brandName}}  {{scope.row.carseriesName}}  {{scope.row.categoryName}}
                                </template>
                            </el-table-column>

                        </el-table>

                    </el-dialog>

                </template>
            </el-table-column>0
        </template>
    </table-template>
</template>
<script>
import TableTemplate from '@/components/TableTemplate'
import ClueDialog from '@/components/ClueDialog'
import Config from '@/framework/configs/Config'
import BasicModel from '@/framework/basic/BasicModel'
export default {
  name: 'fans-index',
  data () {
    return {
      createTimeSearch: null,
      carInfoDatas: null,
      dialogCarInfoFormVisible: false,
      queryParams: {
        role: 4,
        createTimeSearchStart: null,
        createTimeSearchEnd: null,
        timeType: 1,
        keyword: null,
        isCar: null
      },
      carInfoParams: {
        lcwpUserId: null
      },
      innerContent: [],
      imageBaseUrl: Config.imageUrl
    }
  },
  created () {
    const h = this.$createElement
    const input = h('input', {
      attrs: {
        class: 'el-input__inner',
        type: 'number',
        min: 1,
        placeholder: '请输入充值数量'
      }
    })

    const div = h('div', {
      domProps: {
        innerHTML: "<p style='margin-top:10px;font-weight: bold;'>温馨提示：</p>" +
                        '<p>1、充值收费等事项，请于线下沟通协商完成。</p>'
      }
    })

    this.innerContent = [input, div]
  },
  components: { ClueDialog, TableTemplate },
  filters: {
    roleFilter (value) {
      let filter_value = '暂无'
      switch (value) {
        case 1:// 会员
          filter_value = '会员'
          break
        case 2:// 经纪人
          filter_value = '经纪人'
          break
        case 3:// 合伙人
          filter_value = '合伙人'
          break
      }
      return filter_value
    },
    realNameAuthStatusFilter (value) {
      let filter_value = '暂无'
      switch (value) {
        case 1:// 未认证
          filter_value = '未认证'
          break
        case 2:// 待审核
          filter_value = '待审核'
          break
        case 3:// 已认证
          filter_value = '已认证'
          break
      }
      return filter_value
    },
    companyAuthStatusFilter (value) {
      let filter_value = '暂无'
      switch (value) {
        case 1:// 未认证
          filter_value = '未认证'
          break
        case 2:// 待审核
          filter_value = '待审核'
          break
        case 3:// 已认证
          filter_value = '已认证'
          break
      }
      return filter_value
    }
  },
  methods: {
    upgradeDealer: function (data) {
      this.$message({
        message: '升级成功！',
        type: 'success'
      })
      this.$refs['member-table-template'].search()
    },
    upgradeFreeAgent: function (data) {
      this.$message({
        message: '升级成功！',
        type: 'success'
      })
      this.$refs['member-table-template'].search()
    },
    showCarInfoData: function (lcwpUserId) {
      this.carInfoParams.lcwpUserId = lcwpUserId
      this.loadCarInfoData()
      this.dialogCarInfoFormVisible = true
    },
    loadCarInfoData: function () {
      let _this = this
      let params = {
        lcwpUserId: this.carInfoParams.lcwpUserId
      }

      let listener = {
        success: function (dataInfo) {
          _this.carInfoDatas = dataInfo.datas
        }
      }
      BasicModel.get(this, '/dbtCard/findMembersCarList.action', params, listener)
    },
    onCreateTimeChanged (datetime) {
      if (!datetime || datetime[0] == null) {
        this.queryParams.createTimeSearchStart = null
        this.queryParams.createTimeSearchEnd = null
        this.$refs['member-table-template'].search()
        return
      }
      this.queryParams.createTimeSearchStart = datetime[0].getTime()
      this.queryParams.createTimeSearchEnd = datetime[1].getTime()
      this.$refs['member-table-template'].search()
    },
    onRealNameAuthConfirm () {
      this.$refs['member-table-template'].search()
    },
    getCompanyColor (status) {
      let color = ''
      switch (status) {
        case 3:// 3-已认证
          color = '#00CC00'
          break
        case 2:// 2-待审核;
          color = '#FF0000'
          break
        default:// 1-未认证;
          color = '#909399'
      }
      return color
    },
    getRealNameAuthColor (status) {
      let color = ''
      switch (status) {
        case 3:// 3-已认证
          color = '#00CC00'
          break
        case 2:// 2-待审核;
          color = '#FF0000'
          break
        default:// 1-未认证;
          color = '#909399'
      }
      return color
    },
    exportExcel: function () {
      let param = {
        role: this.queryParams.role,
        createTimeSearchStart: this.queryParams.createTimeSearchStart,
        createTimeSearchEnd: this.queryParams.createTimeSearchEnd,
        timeType: this.queryParams.timeType,
        keyword: this.queryParams.keyword,
        isCar: this.queryParams.isCar

      }

      let userInfo = JSON.parse(localStorage.userInfo)
      let loginPath = userInfo.loginPath
      let id = null
      if (userInfo.id) {
        id = userInfo.id
      } else if (userInfo.employeeId) {
        id = userInfo.employeeId
      }

      let dataStr = ''
      for (var key in param) {
        if (param.hasOwnProperty(key)) {
          if (!param[key]) {
            continue
          }
          dataStr += '&' + key + '=' + param[key] + ''
        }
      }

      window.location.href = Config.baseUrl + 'dbtCard/exportMembers.action?token=' + userInfo.token + '&channelId=' + id + '&loginAccountId=' + id + '&loginPath=' + loginPath + dataStr
    }
  }
}
</script>
